/* Gloss Nail Bar · Concept B behaviour: reveal-on-scroll, header drawer + dropdowns, open-now (salon time zone),
   claim tab, menu sub-nav, reduced-motion video pause. No dependencies. */
(function () {
  var d = document, root = d.documentElement;
  root.classList.remove('no-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal: 16px rise + fade, once, 80ms stagger inside a group */
  var els = [].slice.call(d.querySelectorAll('.g-r'));
  if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); }
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sib = e.target.parentElement ? [].slice.call(e.target.parentElement.children).filter(function (c) { return c.classList.contains('g-r'); }) : [];
        var i = Math.max(0, sib.indexOf(e.target));
        e.target.style.transitionDelay = Math.min(i, 6) * 80 + 'ms';
        e.target.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2. Ambient video: muted loops; paused under reduced motion and when off screen */
  var vids = [].slice.call(d.querySelectorAll('video[data-g-loop]'));
  vids.forEach(function (v) {
    v.muted = true;
    if (reduce) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} return; }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }); }, { threshold: 0.05 }).observe(v);
    }
  });

  /* 3. Desktop dropdowns: one open at a time, close on outside click / Escape */
  var dds = [].slice.call(d.querySelectorAll('.g-dd'));
  dds.forEach(function (dd) {
    dd.addEventListener('toggle', function () { if (dd.open) dds.forEach(function (o) { if (o !== dd) o.open = false; }); });
    dd.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) dd.open = true; });
    dd.addEventListener('mouseleave', function () { if (matchMedia('(hover:hover)').matches) dd.open = false; });
    /* a mouse click on a summary that hover already opened keeps it open (keyboard Enter still toggles) */
    var sm = dd.querySelector('summary');
    if (sm) sm.addEventListener('click', function (e) { if (e.detail > 0 && dd.open && matchMedia('(hover:hover)').matches) e.preventDefault(); });
  });
  d.addEventListener('click', function (e) { dds.forEach(function (dd) { if (!dd.contains(e.target)) dd.open = false; }); });

  /* 4. Mobile drawer */
  var drawer = d.getElementById('g-drawer');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.querySelectorAll('[data-g-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    d.body.style.overflow = open ? 'hidden' : '';
    if (open) { var x = drawer.querySelector('[data-g-drawer-close]'); if (x) x.focus(); }
  }
  d.querySelectorAll('[data-g-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  d.querySelectorAll('[data-g-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setDrawer(false); dds.forEach(function (dd) { dd.open = false; });
    var c = d.getElementById('g-claim'); if (c) c.classList.remove('is-open');
  });

  /* 5. Open now: computed in the salon's time zone from the same hours record as the schema */
  d.querySelectorAll('[data-g-open]').forEach(function (el) {
    try {
      var h = JSON.parse(el.getAttribute('data-g-open')), tz = el.getAttribute('data-tz') || 'America/New_York';
      var es = el.getAttribute('data-lang') === 'es';
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      var get = function (t) { var p = parts.filter(function (x) { return x.type === t; })[0]; return p ? p.value : ''; };
      var keys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
      var map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var di = map[get('weekday')], now = parseInt(get('hour'), 10) + parseInt(get('minute'), 10) / 60;
      var fmt = function (s) { var p = s.split(':'), hh = parseInt(p[0], 10), m = p[1]; var ap = hh >= 12 ? (es ? 'p. m.' : 'PM') : (es ? 'a. m.' : 'AM'); var h12 = hh % 12 || 12; return h12 + (m && m !== '00' ? ':' + m : '') + ' ' + ap; };
      var today = (h[keys[di]] || 'closed').replace(/\s/g, '');
      var txt, open = false;
      if (today !== 'closed') {
        var t = today.split('-'), o = t[0].split(':'), c = t[1].split(':');
        var on = +o[0] + (+o[1] || 0) / 60, cn = +c[0] + (+c[1] || 0) / 60;
        if (now >= on && now < cn) { open = true; txt = (es ? 'Abierto ahora · hasta las ' : 'Open now · until ') + fmt(t[1]); }
        else if (now < on) { txt = (es ? 'Abre hoy a las ' : 'Opens today at ') + fmt(t[0]); }
      }
      if (!txt) {
        for (var k = 1; k <= 7; k++) {
          var nd = (di + k) % 7, nv = (h[keys[nd]] || 'closed').replace(/\s/g, '');
          if (nv !== 'closed') { var names = es ? ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']; txt = (es ? 'Cerrado · abre ' : 'Closed · opens ') + (k === 1 ? (es ? 'mañana' : 'tomorrow') : names[nd]) + (es ? ' a las ' : ' at ') + fmt(nv.split('-')[0]); break; }
        }
      }
      if (txt) { el.textContent = txt; el.classList.toggle('is-closed', !open); el.hidden = false; }
    } catch (e) {}
  });

  /* 6. Claim-your-spot tab (off by default in Theme settings) */
  var claim = d.getElementById('g-claim');
  if (claim) {
    var path = location.pathname, hide = (claim.getAttribute('data-hide') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var hidden = hide.some(function (p) { return path.indexOf(p) === 0; });
    if (!hidden) { claim.hidden = false; d.body.classList.add('g-has-claim'); }
    var tab = claim.querySelector('[data-g-claim-tab]');
    tab && tab.addEventListener('click', function () { claim.classList.add('is-open'); tab.setAttribute('aria-expanded', 'true'); var f = claim.querySelector('.g-claim__panel a, .g-claim__panel button'); if (f) f.focus(); });
    claim.querySelectorAll('[data-g-claim-close]').forEach(function (x) { x.addEventListener('click', function () { claim.classList.remove('is-open'); tab && tab.setAttribute('aria-expanded', 'false'); tab && tab.focus(); }); });
  }

  /* 7. Menu sub-nav: highlight the category in view */
  var sub = d.querySelector('.g-subnav');
  if (sub && 'IntersectionObserver' in window) {
    var links = [].slice.call(sub.querySelectorAll('a[href^="#"]'));
    var spy = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); }); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    links.forEach(function (a) { var t = d.getElementById(a.getAttribute('href').slice(1)); if (t) spy.observe(t); });
    links.forEach(function (a) { a.addEventListener('click', function () { var t = d.getElementById(a.getAttribute('href').slice(1)); if (t && t.tagName === 'DETAILS') t.open = true; }); });
  }
})();
